import { fetchAPI } from "./base";
import { withoutRemovedPosts } from "../utils/removed-wp-posts";

// Every list below drops REMOVED_WP_POST_SLUGS, so a removed post leaves
// getStaticPaths, the post cards and the sitemap in one place.

export async function getAllWpPosts(first) {
  const data = await fetchAPI(
    `query FetchPosts($first: Int = 10) {
        posts(first: $first, where: {dateQuery: {before: {year: 2023}}}) {
          nodes {
            excerpt
            featuredImage {
              node {
                sourceUrl
                altText
              }
            }
            slug
            title
            categories {
              nodes {
                name
                slug
              }
            }
            date
          }
        }
    }`,
    {
      variables: {
        first,
      },
    }
  );

  return withoutRemovedPosts(data?.posts?.nodes);
}

export async function getAllNewPosts(first) {
    const data = await fetchAPI(
      `query FetchPosts($first: Int = 10) {
          posts(first: $first, where: {dateQuery: {after: {year: 2022}}}) {
            nodes {
              excerpt
              featuredImage {
                node {
                  sourceUrl
                  altText
                }
              }
              slug
              title
              categories {
                nodes {
                  name
                  slug
                }
              }
              date
            }
            pageInfo {
              endCursor
              hasNextPage
              hasPreviousPage
              startCursor
            }
          }
      }`,
      {
        variables: {
          first,
        },
      }
    );  
    if (data?.posts) data.posts.nodes = withoutRemovedPosts(data.posts.nodes)
    return data;
  }

  export async function getAllNewPostsNext(first, nextCursor) {
    const data = await fetchAPI(
      `query FetchPostsNext($first: Int = 10, $nextCursor: String = "YXJyYXljb25uZWN0aW9uOjE0NDg=") {
          posts(first: $first, after: $nextCursor, where: {dateQuery: {after: {year: 2022}}}) {
            nodes {
              excerpt
              featuredImage {
                node {
                  sourceUrl
                  altText
                }
              }
              slug
              title
              categories {
                nodes {
                  name
                  slug
                }
              }
              date
            }
            pageInfo {
              endCursor
              hasNextPage
              hasPreviousPage
              startCursor
            }
          }
      }`,
      {
        variables: {
          first,
          nextCursor,
        },
      }
    ); 
    if (data?.posts) data.posts.nodes = withoutRemovedPosts(data.posts.nodes)
    return data;
  }

  export async function getAllNewPostsPrev(first, prevCursor) {
    const data = await fetchAPI(
      `query FetchPostsNext($first: Int = 10, $prevCursor: String = "YXJyYXljb25uZWN0aW9uOjE0NDg=") {
          posts(first: $first, before: $prevCursor, where: {dateQuery: {after: {year: 2022}}}) {
            nodes {
              excerpt
              featuredImage {
                node {
                  sourceUrl
                  altText
                }
              }
              slug
              title
              categories {
                nodes {
                  name
                  slug
                }
              }
              date
            }
            pageInfo {
              endCursor
              hasNextPage
              hasPreviousPage
              startCursor
            }
          }
      }`,
      {
        variables: {
          first,
          prevCursor,
        },
      }
    );  
    if (data?.posts) data.posts.nodes = withoutRemovedPosts(data.posts.nodes)
    return data;
  }

export async function getWpPostsByCategory(first, categorySlug) {
    const data = await fetchAPI(
        `query FetchPosts($first: Int = 10, $categorySlug: String) {
            posts(
              first: $first
              where: {categoryName: $categorySlug, dateQuery: {before: {year: 2023}}}
            ) {
              nodes {
                excerpt
                featuredImage {
                  node {
                    sourceUrl
                    altText
                  }
                }
                categories {
                  nodes {
                    slug
                  }
                }
                slug
                title
                date
                modified
              }
            }
          }`,
      {
        variables: {
          first,
          categorySlug
        },
      }
    );
  
    return withoutRemovedPosts(data?.posts?.nodes);
  }

  export async function getWpNewPostsByCategory(first, categorySlug) {
    const data = await fetchAPI(
        `query FetchPosts($first: Int = 10, $categorySlug: String) {
            posts(
              first: $first
              where: {categoryName: $categorySlug, dateQuery: {after: {year: 2022}}}
            ) {
              nodes {
                excerpt
                featuredImage {
                  node {
                    sourceUrl
                    altText
                  }
                }
                categories {
                  nodes {
                    slug
                  }
                }
                slug
                title
                date
                modified
              }
            }
          }`,
      {
        variables: {
          first,
          categorySlug
        },
      }
    );
  
    return withoutRemovedPosts(data?.posts?.nodes);
  }

export async function getPostBySlug(slug) {
    const data = await fetchAPI(
      `query GetPost($id: ID = "") {
        post(id: $id, idType: SLUG) {
          content(format: RENDERED)
          featuredImage {
            node {
              sourceUrl
              altText
              description
            }
          }
          slug
          title
          excerpt(format: RENDERED)
          modified
          date
        }
      }`,
      {
        variables: {
          id: slug,
        },
      }
    );
  
    return data?.post;
}

